import { Component } from '@angular/core';

@Component({
  selector: 'restoreid-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
